import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-blue-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <circle cx="14" cy="9" r="2" fill={textColor} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7273 15.9697L10 11L4 19L11 19L16 19L20 19L15.5 14L13.7273 15.9697Z"
      fill={textColor}
    />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <circle cx="18.56" cy="10.2402" r="2.56" fill={textColor} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5701 18.4759L13.2799 12.96L5.43994 23.04H21.1199L26.56 23.04L20.32 14.88L17.5701 18.4759Z"
      fill={textColor}
    />
  </>
);

export const ImageIcon = createSlideIcon(Icon24x24, Icon32x32);
